import { Link } from 'wouter-preact'

import { Button, HorizontalDivider, TextLink, Typography } from 'components'

import { TeamFormHeader, TeamMemberInput, InfoBox } from './components'
import { teamMemberCountState } from '../../state'

const SetupMembers = () => {
	const memberCount = teamMemberCountState.value

	return (
		<div className='flex-1'>
			<TeamFormHeader
				steps={[
					{ number: 1, completed: true, current: false },
					{ number: 2, completed: true, current: false },
					{ number: 3, completed: false, current: true }
				]}
				subtitle='Invite 2 members and give them an appropriate role in the organization'
				title='Welcome to your Team: Testing'
			/>

			<HorizontalDivider className='my-16 xl:my-10' />

			<div className='flex grid-cols-1 flex-col-reverse gap-10 xl:grid xl:grid-cols-[2fr_1fr]'>
				<div>
					{/* Subheader */}
					<Typography color='text-black-100' text='Team Members' variant='h4' />
					<Typography
						class='mt-2'
						color='text-black-200'
						text='Invite 2 members and give them an appropriate role in the organization.'
						variant='text1'
					/>

					{/* Teams list */}
					<div className='mt-10 space-y-10 xl:mt-5 xl:space-y-4'>
						{Array.from({ length: memberCount }).map((_, index) => (
							// eslint-disable-next-line react/no-array-index-key
							<TeamMemberInput index={index} key={index} />
						))}
					</div>

					<HorizontalDivider className='my-16 xl:my-10' />

					{/* Actions */}
					<div className='mb-10 mt-6 flex flex-col-reverse items-center gap-4 md:flex-row md:justify-between xl:mb-0 xl:justify-end'>
						<TextLink
							ariaLabel='Skip Step'
							href='/team-info'
							text='Skip Step'
							variant='secondary'
						/>

						<Link href='/team-info'>
							<Button className='mb-5 md:mb-0' text='Send Invitations' />
						</Link>
					</div>
				</div>

				<div>
					<InfoBox />
				</div>
			</div>
		</div>
	)
}

export { SetupMembers }
